import { Button, useMediaQuery, useTheme, SxProps, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import color from "../../Constants/colors";

const flagPaths: Record<"en" | "de", string> = {
  en: "/united-kingdom.png",
  de: "/germany.png",
};

interface LangSwitchButtonProps {
  sx?: SxProps<Theme>;
}

export const useLanguageSwitch = () => {
  const { i18n } = useTranslation();
  const current: "en" | "de" = i18n.language === "en" ? "en" : "de";
  const next = current === "en" ? "de" : "en";

  const switchLanguage = () => {
    i18n.changeLanguage(next).then(() => {
      localStorage.setItem("i18nextLng", next);
    });
  };

  return {
    current,
    next,
    flagSrc: flagPaths[current],
    switchLanguage,
  };
};

export const LangSwitchButton: React.FC<LangSwitchButtonProps> = ({ sx }) => {
  const theme = useTheme();
  useMediaQuery(theme.breakpoints.down("sm"));
  const {
    current,
    flagSrc,
    switchLanguage: handleLanguageChange,
  } = useLanguageSwitch();

  return (
    <Button
      size="small"
      variant="outlined"
      onClick={handleLanguageChange}
      startIcon={
        <img
          src={flagSrc}
          alt={current === "en" ? "🇬🇧" : "🇩🇪"}
          width={20}
          height={20}
          style={{ display: "block" }}
        />
      }
      sx={{
        backgroundColor: color.white,
        color: color.primary_dark,
        borderColor: color.primary_dark,
        padding: "2px 8px",
        "&:hover": {
          backgroundColor: color.primary_dark,
          color: color.white,
          borderColor: color.white,
        },
        ...sx,
      }}
    >
      {current.toUpperCase()}
    </Button>
  );
};

export default LangSwitchButton;
